import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import { CLUSTER_CONFIG } from './config/constants';
import { getAQIColor } from './utils/aqiUtils';

/**
 * Custom cluster icon creator that shows average AQI color
 */
const createClusterCustomIcon = (cluster) => {
    const markers = cluster.getAllChildMarkers();
    const count = markers.length;

    // Calculate average AQI for color
    let totalAqi = 0;
    let validCount = 0;

    markers.forEach(marker => {
        const aqi = marker.options?.data?.aqi;
        if (aqi && !isNaN(aqi)) {
            totalAqi += Number(aqi);
            validCount++;
        }
    });

    const avgAqi = validCount > 0 ? Math.round(totalAqi / validCount) : 50;
    const color = getAQIColor(avgAqi);

    // Determine size based on count
    let size = 'small';
    let dimension = 40;
    if (count >= 100) {
        size = 'large';
        dimension = 60;
    } else if (count >= 10) {
        size = 'medium';
        dimension = 50;
    }

    return L.divIcon({
        html: `
      <div class="aqi-cluster aqi-cluster-${size}" style="
        background-color: ${color};
        box-shadow: 0 3px 12px ${color}80;
      ">
        <span>${count}</span>
      </div>
    `,
        className: 'aqi-cluster-icon',
        iconSize: L.point(dimension, dimension, true),
    });
};

/**
 * Wrapper component for marker clustering
 */
const MarkerCluster = ({ children }) => {
    return (
        <MarkerClusterGroup
            {...CLUSTER_CONFIG}
            iconCreateFunction={createClusterCustomIcon}
            animate={true}
            animateAddingMarkers={false}
        >
            {children}
        </MarkerClusterGroup>
    );
};

export default MarkerCluster;

